import axios from '@/common/axios'
import urls from '@/common/urls'
import tips from '@/common/tips'
import html2canvas from 'html2canvas'

async function uploadFile(files,reg='jpg|jpeg|png|PNG|JPG',key,url='',item,headers){
  if(!files) return;
  //reg=all表示所有类型
  let RegObj = reg=="all"?new RegExp("^(.+)$"):new RegExp(`^(${reg})$`,"i");
  let fileList = [];
  if(files instanceof FileList){
    for (const file of files) {
      let type = file.name.split('.').slice(-1)
      if(!RegObj.test(type)){
        tips.error({text:`类型必须是${reg.replace(/\|/g,',')}`})
        return '';
      }
      fileList.push(file)
    }
  }else{
    let type = files.name.split('.').slice(-1)
    if(!RegObj.test(type)){
      tips.error({text:`类型必须是${reg.replace(/\|/g,',')}`})
      return '';
    }
    fileList.push(files)
  }
  let data = await requestFile(fileList,key,url,item)
  return url ? data : data
}


async function requestFile(files,key='file',url='',item={},headers){
  let data = new FormData();
  files.forEach(x => {
    data.append(key,x)
  });
  for(let i in item){
    data.append(i,item[i])
  }
  url = url || urls.upload.uploadFile;
  return new Promise(resolve=>{
    axios.post(url,data,headers).then(res=>{
      resolve(res)
    }).catch(err=>{
      resolve({url:""})
    })
  })
}

async function saveImg(dom){
  return new Promise(resolve=>{
    html2canvas(dom).then(canvas => {
      let file = canvas.toDataURL("image/png")
      resolve(file)
    });
  })
}
async function savePage(dom,headers){
  let file = await saveImg(dom);
  let data = await requestFile(file,'file',urls.upload.uploadBase64,headers);
  return data.url;
}

async function uploadBase64(file,url,item,headers){
  let data = await requestFile(file,'file',url || urls.upload.uploadBase64,item,headers);
  return data.url;
}

export default {
  uploadFile,
  requestFile,
  uploadBase64,
  savePage
}